import React, { useMemo } from 'react';
// @ts-ignore — resolved at build time via Vite aliases
import { useContentToken, EditableToken } from '@vibesites/runtime/react';
import type { ComponentContentSchema } from '@vibesites/runtime';
import { getPropertiesByState, normalizeAbbr, getStateName } from './propertyUtils';

export function LocationLinks() {
  const propertiesByState = getPropertiesByState();

  const { states, neighborhoods } = useMemo(() => {
    const stateList: { label: string; href: string }[] = [];
    const cityList: { label: string; href: string }[] = [];

    for (const state of Object.values(propertiesByState)) {
      const abbr = normalizeAbbr(state.abbr || state.name);
      const fullName = getStateName(abbr);

      stateList.push({
        label: `${fullName} Apartments`,
        href: `/apartments/${state.slug}/`,
      });

      for (const city of Object.values(state.cities)) {
        cityList.push({
          label: `${city.name}, ${abbr}`,
          href: `/apartments/${state.slug}/${city.slug}/`,
        });
      }
    }

    stateList.sort((a, b) => a.label.localeCompare(b.label));
    cityList.sort((a, b) => a.label.localeCompare(b.label));

    return { states: stateList, neighborhoods: cityList };
  }, [propertiesByState]);

  if (!states.length) return null;

  const colSize = Math.ceil(neighborhoods.length / 4);
  const cols = Array.from({ length: 4 }, (_, i) =>
    neighborhoods.slice(i * colSize, (i + 1) * colSize)
  ).filter(c => c.length > 0);

  return (
    <section className="case-locations">
      <div className="case-container">
        <div className="case-locations-grid">
          <div>
            <EditableToken path="socialhub.states_title" type="text" label="States Column Title" defaultValue={contentSchema.tokens['socialhub.states_title'].defaultValue} as="h2" style={{ fontSize: 21, fontWeight: 500, marginBottom: 25 }}>
              {useContentToken('socialhub.states_title')}
            </EditableToken>
            <ul>
              {states.map(s => (
                <li key={s.href}><a href={s.href}>{s.label}</a></li>
              ))}
            </ul>
          </div>

          <div>
            <EditableToken path="socialhub.neighborhoods_title" type="text" label="Neighborhoods Column Title" defaultValue={contentSchema.tokens['socialhub.neighborhoods_title'].defaultValue} as="h2" style={{ fontSize: 21, fontWeight: 500, marginBottom: 25 }}>
              {useContentToken('socialhub.neighborhoods_title')}
            </EditableToken>
            <div className="case-locations-neighborhoods">
              {cols.map((col, ci) => (
                <ul key={ci}>
                  {col.map(n => (
                    <li key={n.href}><a href={n.href}>{n.label}</a></li>
                  ))}
                </ul>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'SocialHub',
  displayName: 'Location Links',
  tokens: {
    'socialhub.states_title': {
      label: 'States Column Title',
      type: 'text',
      defaultValue: 'Locations by State',
    },
    'socialhub.neighborhoods_title': {
      label: 'Neighborhoods Column Title',
      type: 'text',
      defaultValue: 'Locations by Neighborhood',
    },
  },
};

(LocationLinks as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default LocationLinks;
